export const CONSTANT_ERROR = 'CONSTANT_ERROR';
export const CONSTANT_LOADING = 'CONSTANT_LOADING';
export const FETCH_COUNTRIES_SUCCESS = 'FETCH_COUNTRIES_SUCCESS';
export const FETCH_BANKS_SUCCESS = 'FETCH_BANKS_SUCCESS';
